const amenityTypes = [
    {
        controlId: 'A/C',
        label: 'A/C',
        formKey: 'airConditioning',
    },
    {
        controlId: 'BalconyOrDeck',
        label: 'Balcony or deck',
        formKey: 'balconyOrDeck',
    },
    {
        controlId: 'Furnished',
        label: 'Furnished',
        formKey: 'furnished',
    },
    {
        controlId: 'HardwoodFloor',
        label: 'Hardwood floor',
        formKey: 'hardwoodFloors',
    },
    {
        controlId: 'WheelchairAccess',
        label: 'Wheelchair access',
        formKey: 'wheelchairAccess',
    },
    {
        controlId: 'GarageParking',
        label: 'Garage parking',
        formKey: 'garageParking',
    },
    {
        controlId: 'Off-streetParking',
        label: 'Off-street parking',
        formKey: 'offStreetParking',
    },
];

const laundryTypes = [
    {
        controlId: 'None',
        label: 'None',
        apiKey: 'None',
    },
    {
        controlId: 'InUnit',
        label: 'In unit',
        apiKey: 'In Unit',
    },
    {
        controlId: 'SharedOrIn-building',
        label: 'Shared or in-building',
        apiKey: 'Shared',
    },
];

const petTypes = [
    {
        controlId: 'NoPetsAllowed',
        label: 'No pets allowed',
        formKey: 'none',
    },
    {
        controlId: 'CatsOK',
        label: 'Cats OK',
        formKey: 'cats',
    },
    {
        controlId: 'SmallDogsOK',
        label: 'Small dogs Ok',
        formKey: 'smallDogs',
    },
    {
        controlId: 'LargeDogsOK',
        label: 'Large dogs Ok',
        formKey: 'largeDogs',
    },
];

export {
    amenityTypes,
    laundryTypes,
    petTypes,
};
